import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/contacts")({
  component: Outlet,
  beforeLoad: (context) => ({
    getTitle: () => context.context.t && context.context.t("Contacts"),
  }),
})
